import { Wallet } from '@/components/icons/wallet'
import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { TOKEN_SYMBOLS } from '@/constants/tokens'
import { formatAmount, formatNativeAmount } from '@/utils/amount'
import { DEFAULT_DECIMALS, NativeTokens, SupportedTokens } from '@trinity/blockchain-common'
import { BalanceQuery, TokenDecimalsQuery, useContractQuery } from '@trinity/blockchain-react'
import { WalletAddress, useWallet } from '@trinity/wallet-react'
import { type FC, useCallback } from 'react'
import { IoChevronDownSharp } from 'react-icons/io5'

const nativeTokenSymbol = TOKEN_SYMBOLS[NativeTokens.Main]

export const ConnectedWalletButton: FC = () => {
    const { address = '', disconnect } = useWallet()
    const { data: balance = BigInt(0) } = useContractQuery(BalanceQuery, address, NativeTokens.Main)
    const { data: utyBalance = BigInt(0) } = useContractQuery(BalanceQuery, address, SupportedTokens.UTY)
    const { data: utyDecimals = DEFAULT_DECIMALS } = useContractQuery(TokenDecimalsQuery, SupportedTokens.UTY)

    const handleDisconnect = useCallback(() => {
        disconnect()
    }, [disconnect])

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="secondary">
                    <Wallet className="size-4 [&_*]:fill-transparent [&_*]:stroke-primary [&_*]:stroke-1" />
                    <WalletAddress address={address} format="short" />
                    <IoChevronDownSharp />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <DropdownMenuLabel>
                    <WalletAddress address={address} format="long" />
                </DropdownMenuLabel>
                <DropdownMenuLabel>
                    {nativeTokenSymbol}: {formatNativeAmount(balance)}
                </DropdownMenuLabel>
                <DropdownMenuLabel>UTY: {formatAmount(utyBalance, utyDecimals)}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem>
                    <Button variant="destructive" className="w-full" onClick={handleDisconnect}>
                        Disconnect
                    </Button>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
